import { useState } from 'react';
import GirlPhoto from '../GirlPhoto';
import './ContestantsArea.css'

function ContestantsArea({ availableGirls, handleClick, girlSelected }) {
  const girls_list = "nana,dohwa,riina,miru,bora,sangah,seoyeon,soeun,suyun,soojin,elly,yeoreum,yeonhee,yeeun,wooyeon,yuki,zoa,jooe,juri,jiwoo,jiwon,jihan,chaerin,kei,fye,hwiseo".split(",")

  return(
    <div className="contestants_area">
        <div className='girl_squares'>
          <div className='row1'>
            {girls_list.slice(0,9).map(girlName => <GirlPhoto 
              handleClick={handleClick}  
              girlName={girlName} 
              isAvailable={availableGirls.includes(girlName)}
              isSelected={girlSelected == girlName}
              />)}
          </div>
          <div className='row2'>
            {girls_list.slice(9, 18).map(girlName => <GirlPhoto 
            handleClick={handleClick} 
            girlName={girlName} 
            isAvailable={availableGirls.includes(girlName)}
            isSelected={girlSelected == girlName}
            />)}
          </div>
          <div className='row3'>
            {girls_list.slice(18, girls_list.length).map(girlName => <GirlPhoto 
            handleClick={handleClick} 
            girlName={girlName}
            isAvailable={availableGirls.includes(girlName)}
            isSelected={girlSelected == girlName}
            />)}
          </div>
        </div>
    </div>
  )
}

export default ContestantsArea;